import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            多元直播分类
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            无论是才艺表演、游戏陪玩还是生活分享，总有一个分类适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${cat.color} text-background-50 mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-lg mb-2">
                {cat.name}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-foreground-400 text-xs">{cat.count} 位主播</span>
                <span className="flex items-center gap-1 text-primary-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  查看全部
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}